import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

export const useFetchCommentReplies = (
  commentId: string,
  enabled: boolean,
  limit = 20,
) =>
  useInfiniteQuery({
    queryKey: ["blog-comment-replies", commentId, limit],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await fetchClient.GET("/blog/comments/{id}/replies", {
        params: {
          path: { id: commentId },
          query: { page: typeof pageParam === "number" ? pageParam : 1, limit },
        },
      });
      const err = (response as { error?: unknown }).error;
      if (err) throw err;
      // response.data is typed `never` because the OpenAPI spec omits a response body;
      // cast through unknown to recover the runtime value.
      // biome-ignore lint/suspicious/noExplicitAny: untyped endpoint response
      return (response as unknown as { data?: unknown }).data as any;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage?.data?.pagination as
        | { hasNextPage?: boolean; page?: number }
        | undefined;
      return p?.hasNextPage ? (p.page ?? 1) + 1 : undefined;
    },
    enabled: enabled && !!commentId,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
